const __WEBPACK_NAMESPACE_OBJECT__ = require("discourse/lib/case-converter");